import React, { Fragment, useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Spinner from '../layout/Spinner';
import logo from '../../img/ascorel.png';
import { sendLinkRestPwd } from '../../actions/user';
import Card from 'react-bootstrap/Card';
import { GrCodepen } from 'react-icons/gr';
import { MdOutgoingMail } from 'react-icons/md';
import Form from 'react-bootstrap/Form';
import { useTranslation, Trans } from 'react-i18next';

const VerifyEmailResetPassword = ({ sendLinkRestPwd }) => {
  const [sent, setSent] = useState(false);
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    identifiant: ''
  });

  const { identifiant } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setSent(true);
    sendLinkRestPwd(formData);
  };

  return (
    <section className="container">
      <Fragment>
        {/* <h4 className="p-3 mb-2 bg-ascorel text-white text-center">
              Mot de passe
            </h4> */}
        <div className="parent-flex">
          <div>
            <img src={logo} alt="logo" height="100" />
          </div>
        </div>
        <div>
          {!sent ? (
            <Fragment>
              <Card className="card-style-activate">
                <GrCodepen
                  size={96}
                  className="icon-center my-3"
                  color="white"
                />
                <Card.Body className="col-6">
                  <Trans>
                    <Card.Title className="card-header-color-title-activate text-center">
                      {t('ver_email_title1')}
                    </Card.Title>
                    <Card.Title className="card-header-color-title-activate text-center">
                      {t('ver_email_title2')}
                    </Card.Title>
                  </Trans>
                  <Card.Text
                    className="card-header-color text-center"
                    style={{ marginTop: '5rem' }}
                  >
                    <form className="form" onSubmit={(e) => onSubmit(e)}>
                      <div className="form-group">
                        <Trans>
                          <Form.Control
                            type="email"
                            name="identifiant"
                            placeholder="Email"
                            value={identifiant}
                            onChange={(e) => onChange(e)}
                          />
                        </Trans>
                        <small className="form-text-white">
                          {t('ver_email_hint')}
                        </small>
                      </div>
                      <Trans>
                        <input
                          type="submit"
                          className="btn btn-light"
                          value={t('send')}
                        />
                      </Trans>
                    </form>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Fragment>
          ) : (
            <Fragment>
              <Card className="card-style-activate">
                <MdOutgoingMail
                  size={96}
                  className="icon-center my-3"
                  color="white"
                />
                <Card.Body>
                  <Trans>
                    <Card.Title className="card-header-color-title-activate text-center">
                      {t('ver_email_done')}
                    </Card.Title>
                  </Trans>
                </Card.Body>
              </Card>
            </Fragment>
          )}
        </div>
      </Fragment>
    </section>
  );
};

VerifyEmailResetPassword.propTypes = {
  sendLinkRestPwd: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  sendLinkRestPwd
})(VerifyEmailResetPassword);
